import APIService from '../api.service';

export const List = (params) => {
    return APIService.get(`/v01/par-levels`, {
        params: {
            shop_id: params.shop_id,
            page: params.page,
            per_page: params.per_page,
            sku: params.sku,
            keyword: params.keyword,
        },
    });
};

export const CreateForProduct = (body, config = {}) => {
    return APIService.post(`/v01/par-levels/create-for-product`, body, config);
};

export const BulkUpdate = (body, config = {}) => {
    return APIService.post(`/v01/par-levels/bulk`, body, config);
};

export const Import = (body, config = {}) => {
    return APIService.post(`/v01/par-levels/import`, body, config);
};

export const QueueExport = (payload) => {
    return APIService.get('/v01/par-level-template-export', {
        params: {
            ...payload
        }
    });
};

export const CheckExportStatus = (payload) => {
    return APIService.get('/v01/check-par-level-template-status', {
        params: {
            ...payload
        }
    });
};

export const DownloadExportFile = (payload) => {
    return APIService.get('/v01/download-par-level-template', {
        params: {
            ...payload
        },
        responseType: 'blob',
        headers: {
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
    });
};

const ParLevelService = {
    List,
    BulkUpdate,
    Import,
    QueueExport,
    CheckExportStatus,
    DownloadExportFile,
    CreateForProduct
};

export default ParLevelService;
